import select from 'dom-select'
import { classy as cl } from './classy'
import styles from './mapStyles.json'
import MarkerClusterer from '@googlemaps/markerclustererplus';
import GoogleMapsLoader from 'google-maps';

GoogleMapsLoader.KEY = window.gmapikey
GoogleMapsLoader.VERSION = '3.47'


const mapsXmas = function (parent, onReady) {
  parent = parent || document
  //console.log('xmas');
  var mobilePadding = 'active'
  var locationcards = select.all('.xmas-container .location-cards')

   
  function scrollToMapTop(){
      
    var element = document.querySelector('.is-cover');
    var offset = 80;
    var elementPosition = element.getBoundingClientRect().bottom;
    var winodwOffset = window.pageYOffset
    var offsetPosition = elementPosition - offset + winodwOffset;
    //console.log('pos: '+offsetPosition);
    if (element) {
      window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
      });
    }
    
  }
  
  
  function hideCards() {
    cl(locationcards).rmCls(mobilePadding)
    setTimeout(() => {
      scrollToMapTop()
    },100)
  }

  function showMarker(locations){
    const activeLocations = select.all('.location-city.active')
    
    cl(locationcards).addCls(mobilePadding)
    cl(activeLocations).rmCls('active')
    
    function showSingleMarker(location) {
      const activeTrigger = select('[data-map-city="city-'+location['_city']+'"]', location.content)
      if (activeTrigger) {
        cl(activeTrigger).addCls('active')
      }
    }
    //locations.isArray
    if( Array.isArray(locations) ){
      locations.forEach((location) => {
        showSingleMarker(location)
      });
    }else{
      showSingleMarker(locations)
    }
    
    scrollToMapTop()

  }
  
  
  let pageMaps = []
  loader.load(function (google) {
    const markerIcon = {
      icon: "/assets/images/bow-pin.png",
      anchor: new google.maps.Point(16, 22),
      strokeWeight: 0,
      scale: 1,
      size: new google.maps.Size(45,36),
    }

    pageMaps = select.all('.xmas.map', parent).map(mapEl => {
      let center
      const position = mapEl.dataset.lat && mapEl.dataset.lng ? new google.maps.LatLng(Number(mapEl.dataset.lat), Number(mapEl.dataset.lng)) : false
      var zoom = 5
      if( window.innerWidth >= 768 ){
        zoom = 6.2
      }
      // if( window.innerWidth >= 1200 ){
      //   zoom = 7  
      // }
      
      const pins = mapEl.dataset.pins ? JSON.parse(mapEl.dataset.pins) : []
      let markers = []
      let loaded = false
      

      if (position) {
        const map = new google.maps.Map(mapEl, {
          center: position,
          minZoom: 5, 
          maxZoom: 6.2,
          zoom: zoom,
          disableDefaultUI: true,
          draggable: false,
          zoomControl: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          keyboardShortcuts: false,
          styles: styles
        }) 
        
        
        // Christmas updates
        const bounds = new google.maps.LatLngBounds(
          // new google.maps.LatLng(-54.78211604927845, 149.30926728387598),
          new google.maps.LatLng(-50.97141148905764, 157.06892898452602),
          // -50.50394036609015, 155.81537183815567
          
          // new google.maps.LatLng(-25.0477075187577, -164.5679198406187)
          new google.maps.LatLng(-29.056036120967065, -170.25481328124394)
          // -29.865821360101247, -169.59966746712462
        );
        
        
        
        const srcImage = "/assets/images/RBI0178-Map-with-Ribbon_V5.jpg"
        
        class ImageOverlay extends google.maps.OverlayView {
          // bounds_;
          // image_;
          // div_;
          constructor(bounds, image) {
            super();
            // Initialize all properties.
            this.bounds_ = bounds;
            this.image_ = image;
            // Define a property to hold the image's div. We'll
            // actually create this div upon receipt of the onAdd()
            // method so we'll leave it null for now.
            this.div_ = null;
          }
          /**
           * onAdd is called when the map's panes are ready and the overlay has been
           * added to the map.
           */
          onAdd() {
            this.div_ = document.createElement("div");
            this.div_.style.borderStyle = "none";
            this.div_.style.borderWidth = "0px";
            this.div_.style.position = "absolute";
        
            // Create the img element and attach it to the div.
            const img = document.createElement("img");
        
            img.src = this.image_;
            img.style.width = "100%";
            img.style.height = "100%";
            img.style.position = "absolute";
            img.style.opacity = "1";
            this.div_.appendChild(img);
        
            // Add the element to the "overlayLayer" pane.
            const panes = this.getPanes();
        
            panes.overlayLayer.appendChild(this.div_);
          }
          draw() {
            // We use the south-west and north-east
            // coordinates of the overlay to peg it to the correct position and size.
            // To do this, we need to retrieve the projection from the overlay.
            const overlayProjection = this.getProjection();
            // Retrieve the south-west and north-east coordinates of this overlay
            // in LatLngs and convert them to pixel coordinates.
            // We'll use these coordinates to resize the div.
            const sw = overlayProjection.fromLatLngToDivPixel(
              this.bounds_.getSouthWest()
            );
            const ne = overlayProjection.fromLatLngToDivPixel(
              this.bounds_.getNorthEast()
            );
        
            // Resize the image's div to fit the indicated dimensions.
            if (this.div_) {
              this.div_.style.left = sw.x + "px";
              this.div_.style.top = ne.y + "px";
              this.div_.style.width = ne.x - sw.x + "px";
              this.div_.style.height = sw.y - ne.y + "px";
            }
          }
          /**
           * The onRemove() method will be called automatically from the API if
           * we ever set the overlay's map property to 'null'.
           */
          onRemove() {
            if (this.div_) {
              this.div_.parentNode.removeChild(this.div_);
              this.div_ = null;
            }
          }
        }
        

        const overlay = new ImageOverlay(bounds, srcImage);
        const boundsMarkers = new google.maps.LatLngBounds();
        
        overlay.setMap(map);
        // / christmas end

        google.maps.event.addListener(map, 'idle', function () {
          center = map.getCenter()

          if (onReady && !loaded) {
            loaded = true
            onReady()
          }
        })

        
        
        
        // FIT BOUNDS
        google.maps.event.addDomListener(window, 'resize', function () {
           google.maps.event.trigger(map, 'resize')
        //   //center the map to a specific spot (city)
           map.setCenter(center); 
        //   map.setCenter(boundsMarkers.getCenter());

        //   map.fitBounds(boundsMarkers);
        zoom = 5
        if( screen.width >= 768 ){
          zoom = 6.2
        }
           map.setZoom(zoom);
         })

        
        
        
        
        if (pins.length) {
          markers = pins.map(pin => {
            const marker = new google.maps.Marker({
              position: new google.maps.LatLng(Number(pin.lat), Number(pin.lng)),
              map: map,
              draggable: false,
              icon: {
                url: '/assets/images/bow-pin.png',
                //scaledSize: new google.maps.Size(36,44),
                scaledSize: new google.maps.Size(45,36),
              },
              text: '',
              textColor: 'transparent',
              
            })
            marker._city = pin.city;
            marker._id = pin.id;
            marker.addListener("click", () => {
              //** */
              showMarker(marker);
              
            });
            return marker;
          })
          
          var i = 0;
          for(i=0;i<markers.length;i++) {
            boundsMarkers.extend(markers[i].getPosition());
          }

           
          const markerCluster = new MarkerClusterer(map, markers, {
            // imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
             zoom: false,
             zoomOnClick: false,
             gridSize: 20,
             textColor: 'transparent',
             styles: [1, 2, 3].map(() => ({
               url: "/assets/images/bow-pin.png",
               width: 50,
               height: 40,
               textColor: 'transparent',
             })),
           });
           
           
          
           google.maps.event.clearInstanceListeners(markers)
 
           google.maps.event.addListener(markerCluster, "click", function (c) {

            
            //show only the cards in the cluster
            var clusterLocations = c.markers_;
            showMarker(clusterLocations);

          });
          
         // FIT BOUNDS
         //center the map to a specific spot (city)
          //map.setCenter(center); 
          //map.setCenter(boundsMarkers.getCenter());

          //map.fitBounds(boundsMarkers);
          //map.setZoom(map.getZoom() );

         //remove one zoom level to ensure no marker is on the edge.
         //map.setZoom(map.getZoom()-1); 
          

        } else {
          const marker = new google.maps.Marker({
            position: position,
            map: map,
            icon: markerIcon,
            draggable: false
          })
          
          // marker.addListener("click", () => {

          // });

        }

        return {
          id: mapEl.id,
          map,
          markers,
          reset() {
            map.setZoom(zoom)
            map.setCenter(position)
            hideCards()
          }
        }
      }
    })
  })
  
    this.reset = function(mapId) {
      const map = pageMaps.find(m => m.id === mapId)
      if (map) {
        map.reset()
      }
    }
 
}

export default mapsXmas